// extracted by mini-css-extract-plugin
export var contrastLow = "_3z-1";
export var externalLink = "_3z-2";
export var externalLinkIcon = "_3z-3";
export var link = "_3z-0";
export var linkLabel = "_3z-4";